import React, { useState } from 'react';
import { Menu, MoreVerticalIcon } from 'lucide-react';
import MobileSidebar from '../navigation/MobileSidebar';
import { Footer } from '../../../components/layout/Footer';
import ContextualHelp from '../../../components/help/ContextualHelp';
import { useSettingsEffects } from '../../../hooks/use-settings-effects';
import { useMobileDetection } from '../../hooks/useMobileDetection';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../../../components/ui/dropdown-menu';

interface MobileLayoutProps {
  children: React.ReactNode;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({ children }) => {
  const { orientation } = useMobileDetection();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  // Apply settings effects throughout the app
  useSettingsEffects();

  return (
    <div className="flex flex-col min-h-screen bg-background">
      {/* Mobile-specific header - only show on portrait mode */}
      {orientation === 'portrait' && (
        <header className="bg-background border-b z-30 safe-area-top">
          <div className="container flex h-14 items-center justify-between px-4">
            <button
              className="p-2"
              onClick={() => setSidebarOpen(true)}
              aria-label="Open navigation"
            >
              <Menu className="h-6 w-6" />
            </button>
            <span className="font-bold text-lg text-cricket-green">
              Cricket Scoring
            </span>
            <div className="w-6" /> {/* Spacer for alignment */}
          </div>
        </header>
      )}

      {/* Sidebar Drawer */}
      <MobileSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content area */}
      <main className="flex-grow container mx-auto px-2 py-2 safe-area-top safe-area-bottom">
        <div className="mobile-scroll">
          {children}
        </div>
      </main>

      {/* Footer - simplified for mobile */}
      <Footer />

      {/* Contextual help */}
      <ContextualHelp />

      <span style={{color: 'red'}}>MOBILE LAYOUT ACTIVE</span>
    </div>
  );
};

export default MobileLayout; 